import { DailyLetter, DailyLetterViewRecord, CoupleSettings, VisitorInfo } from '../types';

/**
 * Resolves the viewer identity based on IP address, hardware model, device brand,
 * OS, geolocation, and active session profiles.
 */
export function resolveLetterViewer(
  visitor: VisitorInfo | null | undefined,
  settings: CoupleSettings,
  letter?: DailyLetter | null
): DailyLetterViewRecord {
  const nowIso = new Date().toISOString();
  let profile: string | null = null;
  try {
    profile = typeof window !== 'undefined' ? localStorage.getItem('couple_active_profile') : null;
  } catch {}
  const p1Name = settings.partner1Name || settings.partner1Title || 'Novio';
  const p2Name = settings.partner2Name || settings.partner2Title || 'Novia';

  const ip = visitor?.ip && visitor.ip !== 'IP no detectada' ? visitor.ip : '';
  const brand = visitor?.brand || '';
  const model = visitor?.model || '';
  const os = visitor?.os && visitor.os !== 'Desconocido' ? visitor.os : '';
  const browser = visitor?.browser || '';

  // Extract clean device string
  let cleanDevice = '';
  if (brand && model && !model.toLowerCase().includes(brand.toLowerCase())) {
    cleanDevice = `${brand} ${model}`.trim();
  } else if (model) {
    cleanDevice = model.trim();
  } else if (brand) {
    cleanDevice = brand.trim();
  } else if (typeof navigator !== 'undefined' && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
    cleanDevice = 'Dispositivo Móvil';
  } else {
    cleanDevice = 'Navegador Web';
  }

  const city = visitor?.city && visitor.city !== 'Desconocida' ? visitor.city : undefined;
  const country = visitor?.country && visitor.country !== 'Desconocido' ? visitor.country : undefined;

  let viewerName = '';
  let isMatchedPartner = false;

  // 1. Explicit Profile in current browser session
  if (profile === 'novia') {
    viewerName = p2Name;
    isMatchedPartner = true;
  } else if (profile === 'novio') {
    viewerName = p1Name;
    isMatchedPartner = true;
  }
  // 2. IP matching with registered Partner IPs
  else if (ip && settings.partner1Ips?.includes(ip)) {
    viewerName = p1Name;
    isMatchedPartner = true;
  } else if (ip && settings.partner2Ips?.includes(ip)) {
    viewerName = p2Name;
    isMatchedPartner = true;
  }
  // 3. Hardware device matching
  else if (
    settings.partner1Devices?.some(
      (d) => d && (cleanDevice.toLowerCase().includes(d.toLowerCase()) || d.toLowerCase().includes(cleanDevice.toLowerCase()))
    )
  ) {
    viewerName = p1Name;
    isMatchedPartner = true;
  } else if (
    settings.partner2Devices?.some(
      (d) => d && (cleanDevice.toLowerCase().includes(d.toLowerCase()) || d.toLowerCase().includes(cleanDevice.toLowerCase()))
    )
  ) {
    viewerName = p2Name;
    isMatchedPartner = true;
  }
  // 4. Recipient dedication heuristic:
  // If the letter was specifically dedicated to partner 2, and the reader is visiting the app
  else {
    const recipient = letter?.letterContent?.recipientName?.trim();
    if (recipient && p2Name && recipient.toLowerCase().includes(p2Name.toLowerCase())) {
      viewerName = p2Name;
      isMatchedPartner = true;
    } else {
      viewerName = p2Name || 'Pareja';
      isMatchedPartner = true;
    }
  }

  return {
    openedAt: nowIso,
    viewerName,
    deviceModel: `${cleanDevice}${os ? ` • ${os}` : ''}`,
    ip: ip || 'IP no detectada',
    city,
    country,
    browser: browser || undefined,
    os: os || undefined,
    isMatchedPartner,
  };
}
